export default {"src":"/_next/static/media/toothMagnifying_24.18733ac6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};